import { render, staticRenderFns } from "./WguApp.vue?vue&type=template&id=24bffa3c&scoped=true&"
import script from "./WguApp.vue?vue&type=script&lang=js&"
export * from "./WguApp.vue?vue&type=script&lang=js&"
import style0 from "./WguApp.vue?vue&type=style&index=0&id=24bffa3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bffa3c",
  null
  
)

export default component.exports